interface StatusCodeInfo {
  header?: string;
  subHeader: string;
}

// Map new error codes to corresponding labels
const httpStatusMessages: { [code: string]: StatusCodeInfo } = {
  'GR-0103': {
    subHeader: 'validation.immigration.document.number.already.entered',
  },
};

export const getStatusMessage = (errorCode: string, bundle: any): string => {
  if (errorCode) {
    const { header, subHeader } = httpStatusMessages[errorCode] || {};
    const labelHeader = header && bundle ? bundle[header] : '';
    const labelSubHeader = subHeader && bundle ? bundle[subHeader] : '';
    const errorMessage = labelHeader && labelSubHeader ? `${labelHeader}. ${labelSubHeader}` : labelSubHeader;
    return errorMessage;
  }
  return '';
};
